export function SetFileName(companyName: string, opportunityYears: string, title: string, fileType: string){
    return `${companyName}_${opportunityYears}_${title}.${fileType}`;
    
}